export const checkDevEnv = (): boolean => import.meta.env.DEV;
